import styled from "styled-components";
import { device } from "../../styles/device";

export const Container = styled.div`
    padding-bottom: 21px;
    border-bottom: 1px solid ${props => props.theme.colors.neutral100};
    margin-bottom: 23px;

    .title-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        margin-bottom: 11px;
    }

    h2{
        font-size: 16px;
        font-weight: 700;
        color: ${props => props.theme.colors.neutral900};
        margin-bottom: 0;
    }

`;

export const Options = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;

    .list {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 17px;

        @media ${device.laptop} {
            flex-direction: row;
        }
    }

    .delivery-hint {
        color: ${props => props.theme.colors.neutral600};
        font-size: 14px;
    }
`;

export const PickupContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const IconBadge = styled.div`
    display: flex;
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background: ${props => props.muted ? props.theme.colors.neutral100 : props.theme.colors.primary40};
    color: ${props => props.muted ? props.theme.colors.neutral400 : props.theme.colors.primary};
    transition: background .2s ease, color .2s ease;
`;

export const Card = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    border: 1px solid ${props => props.selected ? props.theme.colors.primary : props.theme.colors.gray};
    background: ${props => props.disabled ? props.theme.colors.neutral100 : props.selected ? props.theme.colors.primary40 : props.theme.colors.white};
    border-radius: 16px;
    box-shadow: var(--cards);
    padding: 20px;
    cursor: ${props => props.disabled ? "not-allowed" : "pointer"};
    opacity: ${props => props.disabled ? 0.7 : 1};

    .header {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
    }

    .line {
        display: flex;
        flex-direction: row;
        flex: 1;
        min-width: 0;
        gap: 10px;
        align-items: center;
    }

    .content {
        display: flex;
        flex-direction: column;
        min-width: 0;

        p {
            font-size: 1.2rem;
            line-height: 1.8rem;
        }

        .description {
            font-weight: 700;
            font-size: 1.4rem;
            line-height: 2.1rem;
            color: ${props => props.muted ? props.theme.colors.neutral600 : props.theme.colors.neutral900};
        }

        .time {
            font-weight: 600;
            color: ${props => props.muted ? props.theme.colors.neutral400 : props.theme.colors.primary};
        }

        .price {
            font-weight: 600;
            color: ${props => props.theme.colors.neutral900};
        }

        .price-free {
            color: ${props => props.theme.colors.primary} !important;
        }
    }

    .choose-address-btn {
        display: flex;
        gap: 6px;
        background: transparent;
        align-items: center;
        border: none;
        color: ${props => props.theme.colors.primary};
        font-size: 14px;
        font-weight: 700;
        justify-content: flex-end;
    }

    :hover:not([disabled]) {
        border: 1px solid ${props => props.theme.colors.primary};
    }
`;

export const Divider = styled.div`
    height: 1px;
    background: ${props => props.theme.colors.neutral100};
    margin: 16px 0;
`;

// Endereço de entrega ou loja de retirada da opção escolhida, abaixo dos cartões.
export const DetalheEntrega = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    border: 1px solid ${props => props.theme.colors.primary};
    background: ${props => props.theme.colors.primary40};
    border-radius: 16px;
    padding: 20px;

    .choose-address-btn {
        display: flex;
        gap: 6px;
        background: transparent;
        align-items: center;
        border: none;
        color: ${props => props.theme.colors.primary};
        font-size: 14px;
        font-weight: 700;
        justify-content: flex-end;
        cursor: pointer;
    }
`;
